export enum ElectionType {
  PRESIDENTIAL = 'presidential',
  PARLIAMENTARY = 'parliamentary',
  REGISTERED_VOTERS = 'registered_voters'
}
